import React, { useState, useEffect } from 'react'
import headerImage from '../../../../../assets/images/header-img.png'
import Interests from "./Components";
import { Link } from 'react-router-dom'

export const InterestsView = () => {
  
  const interests = [
    {id: 1,interest: 'Reservation'},
    {id: 2,interest: 'Appointment'},
    {id: 3,interest: 'Demo'},
    {id: 4,interest: 'Service'},
    {id: 5,interest: 'Webinar'},
    {id: 6,interest: 'Seminar'},
    {id: 7,interest: 'Online Classes'},
    {id: 8,interest: 'Custom Booking'}
  ];

  const [selectedInterests, setSelectedInterests] = useState([])

  // Load selected interests from localStorage on component mount
  useEffect(() => {
    const savedInterests = localStorage.getItem('selectedInterests')
    if (savedInterests) {
      try {
        setSelectedInterests(JSON.parse(savedInterests))
      } catch (error) {
        console.error('Error parsing saved interests:', error)
      }
    }
  }, [])

  // Save selected interests to localStorage whenever selection changes
  useEffect(() => {
    localStorage.setItem('selectedInterests', JSON.stringify(selectedInterests))
  }, [selectedInterests])

  const handleInterestToggle = (interestId) => {
    setSelectedInterests(prev => {
      if (prev.includes(interestId)) {
        // Remove interest if already selected
        return prev.filter(id => id !== interestId)
      } else {
        // Add interest if not selected
        return [...prev, interestId]
      }
    })
  }

  return (
    <div className="interests wrapper">
      <h1 className="heading">Say Goodbye To Frustrating Back-And-Forths</h1>
      <p className="mb-4 mt-2">Sign Up Today</p>
      <div className="interest-btns">
        {interests.map((interest) => (
          <Interests 
            key={interest.id} 
            interests={interest} 
            isSelected={selectedInterests.includes(interest.id)}
            onToggle={handleInterestToggle}
          />
        ))}
      </div>
      <div className="started-btn">
        <Link to='/signup'><button className="btn">Get Started</button></Link>
      </div>
      <div className="header-img">
        <img src={headerImage}/>
      </div>
    </div>
  )
}
